(function () {
  'use strict';

  const OTP_ENDPOINT = 'https://script.google.com/macros/s/AKfycbzNOPZ1Aa7hzgo7h0PDcjxR61epFjWIgTq-BuUcb8bB2qh-lrYPloXI1BlweH94LsTzng/exec';
  const DEMO_MODE = false;
  const RESEND_COOLDOWN_SECONDS = 30;

  let pendingForm  = null;
  let pendingEmail = null;
  let resendTimer  = null;
  let iti          = null;

  const modal           = () => document.getElementById('otp-modal');
  const overlay         = () => document.getElementById('otp-modal-overlay');
  const closeBtn        = () => document.getElementById('otp-modal-close');
  const step1           = () => document.getElementById('otp-step-1');
  const step2           = () => document.getElementById('otp-step-2');
  const step3           = () => document.getElementById('otp-step-3');
  const phoneInput      = () => document.getElementById('otp-phone-input');
  const phoneError      = () => document.getElementById('otp-phone-error');
  const phoneDisplay    = () => document.getElementById('otp-phone-display');
  const codeInput       = () => document.getElementById('otp-code-input');
  const codeError       = () => document.getElementById('otp-code-error');
  const sendBtn         = () => document.getElementById('otp-send-btn');
  const verifyBtn       = () => document.getElementById('otp-verify-btn');
  const resendLink      = () => document.getElementById('otp-resend-link');
  const resendCountdown = () => document.getElementById('otp-resend-countdown');
  const successClose    = () => document.getElementById('otp-success-close');

  function openModal() {
    modal().classList.add('is-open');
    modal().setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => phoneInput() && phoneInput().focus(), 50);
  }

  function closeModal() {
    modal().classList.remove('is-open');
    modal().setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    clearResendTimer();
    resetModal();
  }

  function resetModal() {
    showStep(1);
    if (iti) iti.setNumber('');
    if (codeInput()) codeInput().value = '';
    clearError(phoneError());
    clearError(codeError());
    setLoading(sendBtn(), false);
    setLoading(verifyBtn(), false);
  }

  function showStep(n) {
    [step1(), step2(), step3()].forEach((el, i) => {
      if (!el) return;
      el.classList.toggle('otp-modal__step--hidden', i !== n - 1);
    });
  }

  function getE164Phone() {
    return iti ? iti.getNumber() : '';
  }

  function isValidPhone() {
    return iti ? iti.isValidNumber() : false;
  }

  function isValidCode(code) {
    return /^\d{6}$/.test(code.trim());
  }

  function setError(el, msg)  { if (el) el.textContent = msg; }
  function clearError(el)     { if (el) el.textContent = ''; }

  function setLoading(btn, state) {
    if (!btn) return;
    btn.classList.toggle('is-loading', state);
    btn.disabled = state;
  }

  function startResendCountdown() {
    let seconds = RESEND_COOLDOWN_SECONDS;
    resendLink().classList.add('otp-modal__resend-link--hidden');
    resendCountdown().textContent = `Resend in ${seconds}s`;
    resendTimer = setInterval(() => {
      seconds--;
      if (seconds <= 0) {
        clearResendTimer();
        resendCountdown().textContent = '';
        resendLink().classList.remove('otp-modal__resend-link--hidden');
      } else {
        resendCountdown().textContent = `Resend in ${seconds}s`;
      }
    }, 1000);
  }

  function clearResendTimer() {
    if (resendTimer) {
      clearInterval(resendTimer);
      resendTimer = null;
    }
  }

  async function sendOTP(phone) {
    if (DEMO_MODE) {
      await new Promise(r => setTimeout(r, 800));
      return { success: true };
    }
    const res = await fetch(OTP_ENDPOINT, {
      method: 'POST',
      body: new URLSearchParams({ payload: JSON.stringify({ action: 'send-otp', phone }) }),
      redirect: 'follow'
    });
    return res.json();
  }

  async function verifyOTP(phone, code) {
    if (DEMO_MODE) {
      await new Promise(r => setTimeout(r, 600));
      return { success: isValidCode(code) };
    }
    const res = await fetch(OTP_ENDPOINT, {
      method: 'POST',
      body: new URLSearchParams({ payload: JSON.stringify({ action: 'verify-otp', phone, code: code.trim() }) }),
      redirect: 'follow'
    });
    return res.json();
  }

  async function handleSend() {
    clearError(phoneError());
    if (!phoneInput().value.trim()) {
      setError(phoneError(), 'Please enter your mobile number.');
      phoneInput().focus();
      return;
    }
    if (!isValidPhone()) {
      setError(phoneError(), 'Please enter a valid mobile number.');
      phoneInput().focus();
      return;
    }
    const phone = getE164Phone();
    setLoading(sendBtn(), true);
    try {
      const result = await sendOTP(phone);
      if (result.success) {
        phoneDisplay().textContent = phone;
        showStep(2);
        startResendCountdown();
        setTimeout(() => codeInput() && codeInput().focus(), 50);
      } else {
        setError(phoneError(), result.error || 'Failed to send code. Please try again.');
      }
    } catch (err) {
      setError(phoneError(), 'Something went wrong. Please try again.');
      console.error('[OTP Gate] send error:', err);
    } finally {
      setLoading(sendBtn(), false);
    }
  }

  async function handleVerify() {
    clearError(codeError());
    const code  = codeInput().value.trim();
    const phone = phoneDisplay().textContent;
    if (!isValidCode(code)) {
      setError(codeError(), 'Please enter the 6-digit code.');
      codeInput().focus();
      return;
    }
    setLoading(verifyBtn(), true);
    try {
      const result = await verifyOTP(phone, code);
      if (result.success) {
        clearResendTimer();
        submitPendingForm();
        showStep(3);
      } else {
        setError(codeError(), result.error || 'Incorrect code. Please try again.');
        codeInput().select();
      }
    } catch (err) {
      setError(codeError(), 'Something went wrong. Please try again.');
      console.error('[OTP Gate] verify error:', err);
    } finally {
      setLoading(verifyBtn(), false);
    }
  }

  function submitPendingForm() {
    if (!pendingForm) return;
    pendingForm.removeEventListener('submit', handleFormSubmit, true);
    pendingForm.submit();
  }

  function handleFormSubmit(e) {
    const form     = e.target;
    const formType = form.querySelector('input[name="form_type"]');
    if (!formType || formType.value !== 'customer') return;
    const emailField = form.querySelector('input[type="email"], input[name="contact[email]"], input[name="customer[email]"]');
    if (!emailField || !emailField.value) return;
    e.preventDefault();
    e.stopPropagation();
    pendingForm  = form;
    pendingEmail = emailField.value;
    openModal();
  }

  async function handleResend() {
    clearError(codeError());
    const phone = phoneDisplay().textContent;
    if (!phone) return;
    resendLink().classList.add('otp-modal__resend-link--hidden');
    try {
      const result = await sendOTP(phone);
      if (result.success) {
        codeInput().value = '';
        startResendCountdown();
        codeInput().focus();
      } else {
        setError(codeError(), result.error || 'Failed to resend. Please try again.');
      }
    } catch (err) {
      setError(codeError(), 'Something went wrong. Please try again.');
    }
  }

  function handleKeydown(e) {
    if (e.key === 'Escape' && modal().classList.contains('is-open')) closeModal();
    if (e.key === 'Enter') {
      if (!step1().classList.contains('otp-modal__step--hidden')) handleSend();
      if (!step2().classList.contains('otp-modal__step--hidden')) handleVerify();
    }
  }

  function handleCodeInput() {
    const val = codeInput().value.replace(/\D/g, '');
    codeInput().value = val;
    if (val.length === 6) handleVerify();
  }

  function init() {
    // Don't initialise on Shopify's post-subscription confirmation reload
    if (window.location.search.includes('customer_posted=true')) return;

    if (!modal()) {
      console.warn('[OTP Gate] Modal element not found.');
      return;
    }

    iti = window.intlTelInput(phoneInput(), {
      initialCountry: 'gb',
      separateDialCode: true,
      preferredCountries: ['gb', 'us', 'au', 'ie', 'ca'],
      utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@23/build/js/utils.js'
    });

    document.addEventListener('submit', handleFormSubmit, true);
    overlay().addEventListener('click', closeModal);
    closeBtn().addEventListener('click', closeModal);
    sendBtn().addEventListener('click', handleSend);
    verifyBtn().addEventListener('click', handleVerify);
    successClose().addEventListener('click', closeModal);
    resendLink().addEventListener('click', handleResend);
    codeInput().addEventListener('input', handleCodeInput);
    document.addEventListener('keydown', handleKeydown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();